import React from 'react';

/** Bottom sheet: what this entry is, then what can be done to it. */
export function ActionSheet({
  kind, title, meta, label = 'ENTRY', children, onDismiss, scrim = true, style
}) {
  return (
    <React.Fragment>
      {scrim ? (
        <div onClick={onDismiss} style={{
          position: 'absolute', inset: 0, background: 'var(--bujo-scrim)'
        }} />
      ) : null}
      <div style={{
        position: 'absolute', left: 0, right: 0, bottom: 0,
        background: 'var(--bujo-surface-sheet)', borderTop: 'var(--bujo-border-heavy)',
        padding: 'var(--bujo-space-5) var(--bujo-gutter) var(--bujo-space-6)', ...style
      }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 'var(--bujo-space-2)' }}>
          <span style={{
            font: 'var(--bujo-fw-bold) var(--bujo-fs-label)/var(--bujo-lh-tight) var(--bujo-font-mono)',
            letterSpacing: 'var(--bujo-ls-label)', color: 'var(--bujo-label)'
          }}>{label}</span>
          {kind ? (
            <span style={{
              font: 'var(--bujo-fw-regular) var(--bujo-fs-label)/var(--bujo-lh-tight) var(--bujo-font-mono)',
              color: 'var(--bujo-text-meta)'
            }}>{kind}</span>
          ) : null}
        </div>
        {title ? (
          <div style={{
            margin: 'var(--bujo-space-3) 0 6px',
            font: 'var(--bujo-fw-regular) var(--bujo-fs-sheet)/var(--bujo-lh-row) var(--bujo-font-mono)',
            color: 'var(--bujo-text-primary)'
          }}>{title}</div>
        ) : null}
        {meta ? (
          <div style={{
            font: 'var(--bujo-fw-regular) var(--bujo-fs-meta)/var(--bujo-lh-row) var(--bujo-font-mono)',
            color: 'var(--bujo-text-meta)'
          }}>{meta}</div>
        ) : null}
        <div style={{ marginTop: 'var(--bujo-space-4)', display: 'flex', flexDirection: 'column' }}>
          {children}
        </div>
      </div>
    </React.Fragment>
  );
}
